module.exports = __webpack_public_path__ + "static/media/horse.ecef57fa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/DynamicContent/About/horse.svg
// module id = 743
// module chunks = 0